<template>
  <div id="crowded">
    <div class="crowded-box">
      <img src="@/assets/img/YonghuiSync/crowded.png" />
      <h1>活动太火爆了，请您稍后尝试！</h1>
      <div class="refresh" @click="doRefresh()">
        <img src="@/assets/img/verifyV2/refresh.png" />刷 新 页 面
      </div>
    </div>
  </div>
</template>

<script>
import { queryVerifyRes } from '@/api/verifyV2.js'
export default {
  data() {
    return {}
  },
  methods: {
    async doRefresh() {
      try {
        const routeQuery = this.$route.query // token, phone, redeemCode
        const { code, message } = await queryVerifyRes({ ...routeQuery })
        if (code !== 0) {
          this.$toast.fail({
            message: message
          })
          // token失效调回首页
          if (code === 5) {
            this.$router.push({
              name: 'verifyV2'
            })
          }
          return
        }
        this.$router.push({
          path: '/verifyV2List',
          query: { ...routeQuery }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="less" scoped>
#crowded {
  background: #ffebd2;
  min-height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  .crowded-box {
    flex: auto;
    & > img {
      display: block;
      margin: auto;
      width: 70.59vw;
    }
    & > h1 {
      font-size: 3.2vw;
      padding: 9.3vw 0 17.3vw;
      color: #999999;
      text-align: center;
    }
    .refresh {
      color: #ea1300;
      font-size: 3.2vw;
      line-height: 1.5;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 3.2vw;
        margin: 0 3vw 0 0;
      }
    }
  }
}
</style>
